import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { environment } from '@env/environment';
import { BillingDataService } from '../data-services/billing-data.service';
import { PaymentServiceService } from '../payment-service/payment-service.service';

@Injectable({
  providedIn: 'root',
})
export class BillingDetailsService {
  constructor(
    private http: HttpClient,
    private billingDataService: BillingDataService,
    private paymentService: PaymentServiceService
  ) {}

  getAllBillingDetailsByPolicy(policyNumber: string) {
    forkJoin(
      this.getCurrentBillByPolicy(policyNumber),
      this.getScheduledBillsByPolicy(policyNumber),
      this.getHistoryBillsByPolicy(policyNumber),
      this.getPendingChecksByPolicy(policyNumber)
    ).subscribe(
      ([
        billingResponse,
        scheduledResponse,
        historyResponse,
        pendingCheckPaymentsResponse,
      ]) => {
        const result = [
          { billingDetails: { ...billingResponse } },
          { billingHistory: historyResponse },
          { scheduledBills: scheduledResponse },
          { pendingCheckPayments: pendingCheckPaymentsResponse },
        ];
        this.billingDataService.updateBillingDetails({ ...result });
      }
    );
  }

  getCurrentBillByPolicy(policyNumber: string) {
    const url = `${environment.backend_server_url_billing}/${policyNumber}/currentbill`;
    return this.http.get(url);
  }

  getScheduledBillsByPolicy(policyNumber: string) {
    const url = `${environment.backend_server_url_billing}/scheduled-bills?policyNumber=${policyNumber}`;
    return this.http.get(url);
  }

  getHistoryBillsByPolicy(policyNumber: string) {
    const url = `${environment.backend_server_url_billing}/history-bills?policyNumber=${policyNumber}`;
    return this.http.get(url);
  }

  getBillingSummaryByPolicy(policyNumber: string) {
    const url = `${environment.backend_server_url_billing}/${policyNumber}/billing-summary`;
    // const url = `/b2c-billing/v1/${policyNumber}/billing-summary`;
    return this.http.get(url);
  }

  getPendingChecksByPolicy(policyNumber: string) {
    const url = `${environment.backend_server_url_billing}/${policyNumber}/unprocessedpayment`;
    return this.http.get(url);
  }
  makeAchECheckPayment(billingData, policyNumber, multiple, storeInstrument) {
    const url = `${environment.backend_server_url_billing}/guest-ach-payment/${policyNumber}?multiple=${multiple}&storeInstrument=${storeInstrument}`;
    return this.http.post(url, billingData);
  }

   makeV2AchECheckPayment(billingData, policyNumber, multiple, storeInstrument) {
    const url = `${environment.backend_server_url_billing}/v2/guest-ach-payment/${policyNumber}?multiple=${multiple}&storeInstrument=${storeInstrument}`;
    // const url = `/b2c-billing/v1/v2/guest-ach-payment/${policyNumber}?multiple=${multiple}&storeInstrument=${storeInstrument}`;

    return this.http.post(url, billingData, { headers: this.getGuestSessionHeaders() });
  }

  makeECheckPayment(
    billingData,
    email,
    policyNumber,
    multiple,
    storeInstrument,
    achGuestBilling
  ) {
    if (achGuestBilling) {
      return this.makeV2AchECheckPayment(
        billingData,
        policyNumber,
        multiple,
        multiple
      );
    } else {
      const url = `${environment.backend_server_url_billing}/${email}/${policyNumber}?multiple=${multiple}&storeInstrument=${storeInstrument}`;
      return this.http.post(url, billingData);
    }
  }

  getCheckDetails(policyNumber) {
    const url = `${environment.backend_server_url_billing}/${policyNumber}/check-details`;
    return this.http.get(url);
  }

  getAccountIdByEmail(email) {
    const url = `${environment.backend_server_url_policy}/${email}/accountname`;
    return this.http.get(url, { responseType: 'text' });
  }

  sendBillingQuestion(billingQuestionPayload, email) {
    const url = `${environment.backend_server_url_policy}/${email}/sendEmail`;
    return this.http.post(url, billingQuestionPayload);
  }

  sendBillingRequestWithAttachment(attachment) {
    const url = `${environment.backend_server_url_policy}/sendEmail/attachments`;    
    return this.http.post(url, attachment);
  }

  private getGuestSessionHeaders(): HttpHeaders {
      const sessionToken = this.paymentService.getGuestSessionToken();
      return new HttpHeaders(
        sessionToken ? { 'X-Guest-Session': sessionToken } : {}
      );
    }
}
